import type { SyncMode, SyncModeReason } from "~/helpers/sw/messageContract";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SyncModeState {
	mode: SyncMode | null;
	reason: SyncModeReason | null;
}

export interface SyncModeRootState {
	syncMode: SyncModeState;
}

const initialState: SyncModeState = { mode: null, reason: null };

export const syncModeSlice = createSlice({
	initialState,
	name: "syncMode",
	reducers: {
		setSyncMode: (state, action: PayloadAction<{ mode: SyncMode; reason?: SyncModeReason }>) => {
			state.mode = action.payload.mode;
			state.reason = action.payload.reason ?? null;
		}
	}
});

export const { setSyncMode } = syncModeSlice.actions;

export const selectSyncMode = (state: SyncModeRootState): SyncModeState => state.syncMode;

export default syncModeSlice.reducer;
